import { ConfigProvider } from "antd";
import { ReactNode, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Locale } from "antd/lib/locale";
import { theme } from "./theme";
import ptBR from "antd/locale/pt_BR";
import enUS from "antd/locale/en_US";
import esES from "antd/locale/es_ES";

interface LayoutProviderProps {
  children: ReactNode;
}

export const LayoutProvider: React.FC<LayoutProviderProps> = ({ children }) => {
  const { i18n } = useTranslation();
  const [locale, setLocale] = useState<Locale>(ptBR);

  useEffect(() => {
    switch (i18n.language) {
      case "en":
        setLocale(enUS);
        break;
      case "es":
        setLocale(esES);
        break;
      default:
        setLocale(ptBR);
    }
  }, [i18n.language]);

  return (
    <ConfigProvider theme={theme} locale={locale}>
      {children}
    </ConfigProvider>
  );
};
